import React from 'react';

interface EyebrowProps {
  children: React.ReactNode;
  className?: string;
}

const Eyebrow: React.FC<EyebrowProps> = ({ children, className = '' }) => (
  <span className={`ds-eyebrow ${className}`}>{children}</span>
);

export default Eyebrow;
